/**
 * Breadcrumb.jsx
 * Reusable breadcrumb for all detail pages (Blog, City, Itinerary).
 *
 * Usage:
 *   <Breadcrumb crumbs={[
 *     { label: "Home", to: "/" },
 *     { label: "Blogs", to: "/blogs" },
 *     { label: "Goa Travel Guide" },   // no `to` = current page (not linked)
 *   ]} />
 *
 * Renders as: Home / Blogs / Goa Travel Guide
 * Last crumb is plain text (aria-current="page").
 */

import React from "react";
import { Link } from "react-router-dom";

export default function Breadcrumb({ crumbs = [] }) {
  if (!crumbs.length) return null;

  return (
    <nav
      aria-label="Breadcrumb"
      className="flex items-center flex-wrap gap-1.5 text-xs text-gray-400 mb-8"
    >
      {crumbs.map((crumb, i) => {
        const isLast = i === crumbs.length - 1;
        return (
          <React.Fragment key={i}>
            {i > 0 && <span className="text-gray-300 select-none">/</span>}
            {isLast || !crumb.to ? (
              <span
                aria-current={isLast ? "page" : undefined}
                className={isLast ? "text-gray-600 font-medium" : "text-gray-400"}
              >
                {crumb.label}
              </span>
            ) : (
              <Link
                to={crumb.to}
                className="hover:text-[#5b7c67] transition-colors duration-150"
              >
                {crumb.label}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
